import React from 'react';
import PropTypes from 'prop-types';
import {
  Box, Checkbox, FormControlLabel, Typography,
} from '@mui/material';
import { Field } from '../../UI';
import { tipoTelefonesTypes } from '../../../../types/tipoTelefonesTypes';

/**
 * Dados do Advogado do cliente (AW2-1136 Etapa 3) — porta de
 * `DadosAdvogadoCliente.jsx` real, sempre somente-leitura. Diferente do
 * Advogado de Devedor (2 campos simples, `nomeAdvogado`/`telefoneAdvogado`
 * como strings planas), aqui o telefone é um sub-objeto completo (Tipo
 * Telefone/DDD/Número/Observação/WhatsApp) — confirmado por leitura direta,
 * mesmo padrão de campos de telefone já usado em `TelefoneCliente.jsx`.
 */
export default function DadosAdvogadoCliente({ nomeAdvogado, telefoneAdvogado }) {
  return (
    <>
      <Typography variant="h3" sx={{ mt: 3, mb: 1.5 }}>Dados do Advogado:</Typography>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: 'repeat(5, minmax(0, 1fr))' },
          gap: 'clamp(10px, 0.8vw, 22px)',
          alignItems: 'end',
        }}
      >
        <Field label="Nome:" value={nomeAdvogado ?? ''} disabled />
        <Field
          label="Tipo de Telefone:"
          value={tipoTelefonesTypes[telefoneAdvogado?.tipoTelefone] ?? ''}
          disabled
        />
        <Field label="DDD:" value={telefoneAdvogado?.ddd ?? ''} disabled />
        <Field label="Telefone:" value={telefoneAdvogado?.numero ?? ''} disabled />
        <Field label="Observação:" value={telefoneAdvogado?.observacao ?? ''} disabled />
      </Box>
      <Box sx={{ mt: 1 }}>
        <FormControlLabel
          control={<Checkbox size="small" checked={Boolean(telefoneAdvogado?.permitirWhatsApp)} disabled />}
          label={<Typography variant="body2">WhatsApp</Typography>}
          sx={{ ml: 0 }}
        />
      </Box>
    </>
  );
}

DadosAdvogadoCliente.propTypes = {
  nomeAdvogado: PropTypes.string,
  telefoneAdvogado: PropTypes.shape({
    tipoTelefone: PropTypes.string,
    ddd: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    numero: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    observacao: PropTypes.string,
    permitirWhatsApp: PropTypes.bool,
  }),
};

DadosAdvogadoCliente.defaultProps = {
  nomeAdvogado: '',
  telefoneAdvogado: null,
};
